<template>
  <div>
    <AdminCategoriesAddSubCategory
      @set-page-attributes="(attr) => $emit('set-page-attributes', attr)"
      @on-show-loader="$emit('on-show-loader')"
      @on-hide-loader="$emit('on-hide-loader')"
      :is_loading="is_loading"
    >
    </AdminCategoriesAddSubCategory>
  </div>
</template>

<script>
import AdminCategoriesAddSubCategory from "./AdminCategoriesAddSubCategory";
export default {
  name: "AdminSubCategoriesAdd",
  components: {
    AdminCategoriesAddSubCategory,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>